import React from 'react';
import ImportWidget from './ImportWidget';

export default class ImportSchedule extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showImporter: false
        };
    }

    import = () => {
        this.setState({ showImporter: true });
    }

    hideImporter = () => {
        this.setState({ showImporter: false });
    }

    render() {
        if (this.state.showImporter) {
            return (
                <ImportWidget
                    { ...this.props }
                    onClose={ this.hideImporter }
                    onImport={ this.props.actions.handleImport } />
            )
        }

        return (
            <p align="right">
                <button
                    className="floaterButton nolimit"
                    type="button"
                    onClick={ this.import }>
                    Import Schedule
                </button>
            </p>
        );
    }
}
